export const pageHeight =  () => {
  const B = document.body
  const H = document.documentElement
  return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight)
}

export const winWidth =  () => {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth
  }
  if (document.body) {
    return document.body.clientWidth
  }
}

export const winHeight = () => {
  if (document.documentElement && document.documentElement.clientHeight) {
    return document.documentElement.clientHeight
  }
  if (document.body) {
    return document.body.clientHeight
  }
}

export const hasBodyClass = (className) => {
  var cl = document.body.classList;
  return cl.contains(className);
}

export const addRemBodyClass = (className, remove) => {
  var cl = document.body.classList,
    hasClass = cl.contains(className)
  if (remove === false) {
    if (hasClass) {
      cl.remove(className)
    }
  } else {
    if (!hasClass) {
      cl.add(className)
    }
  }
  return cl
}

export const addBodyClass = (className) => {
  return addRemBodyClass(className, true);
}

export const removeBodyClass = (className) => {
  return addRemBodyClass(className, false);
}

export const swapBodyClass = (classNameRem, classNameAdd) => {
  removeBodyClass(classNameRem);
  return addBodyClass(classNameAdd);
}

export const expandImagePath = (src, key) => {
  if (src.indexOf('/files/') < 0) {
    switch (key) {
      case 'orig':
        return '/files/' + src
      default:
        return '/files/styles/' + key + '/public/' + src
    }
  }
  return src
}

export const expandFilePath = (path) => {
  return expandImagePath(src, 'orig')
}

export const expandImageSize = (sizes, key) => {
  if (sizes instanceof Object && sizes !== null) {
    if (sizes.hasOwnProperty(key)) {
      return expandImagePath(sizes[key], key)
    }
  }
}

export const expandImageOrig = (sizes, key) => {
  return expandImageSize(sizes, 'orig')
}

export const cleanString = (str) => {
  return str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')
}

export const get = (path) => {
  return document.querySelector(path)
}

export const getCookie = (name) => {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null
}

export const setCookie = (name, value, days) => {
  const d = new Date;
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

export const isDarkMode = () => {
  if (window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } else {
    const hr = new Date().getHours();
    return hr > 21 || hr < 6;
  }

}


// WEBPACK FOOTER //
// ./src/lib/utils.js